import React from "react";
import { useTranslation } from "react-i18next";
import AnimateOnScroll from "./AnimateOnScroll";

export default function Products() {
  const { t } = useTranslation();

  const useCases = [
    t("Product.useCase1"),
    t("Product.useCase2"),
    t("Product.useCase3"),
    t("Product.useCase4"),
    t("Product.useCase5"),
    t("Product.useCase6"),
    t("Product.useCase7"),
    t("Product.useCase8"),
    t("Product.useCase9"),
    t("Product.useCase10"),
  ];

  return (
    <section className="py-20 bg-white" id="product">
      <div className="container">
        <AnimateOnScroll>
          <div className="flex flex-col justify-center items-center text-center">
            <p className="t-h1">{t("Product.label")}</p>
            <h2 className="t-h2">{t("Product.title")}</h2>
            <p
              className="font-semibold mb-2"
              style={{ color: "#010C66", fontFamily: '"Wix Madefor Display", sans-serif', fontSize: "1.05rem" }}
            >
              {t("Product.tagline")}
            </p>
            <p className="text-slate-400 dark:text-slate-300 max-w-2xl mx-auto">
              {t("Product.intro")}
            </p>
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeUp" delay={100}>
          <div className="mt-10 max-w-3xl mx-auto">
            <p
              className="text-xs font-semibold uppercase tracking-widest mb-4 text-center"
              style={{ color: "#9ca3af" }}
            >
              {t("Product.useCasesLabel")}
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              {useCases.map((useCase, i) => (
                <span
                  key={i}
                  className="px-4 py-2 rounded-full text-sm font-medium"
                  style={{ background: "#f0f2ff", color: "#010C66" }}
                >
                  {useCase}
                </span>
              ))}
            </div>
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeUp" delay={150}>
          <div
            className="mt-10 max-w-3xl mx-auto rounded-2xl p-6 text-center"
            style={{ background: "linear-gradient(135deg, #010C66 0%, #1a237e 100%)" }}
          >
            <p className="text-white font-semibold" style={{ fontFamily: '"Wix Madefor Display", sans-serif', fontSize: "1.05rem" }}>
              {t("Product.valueProp")}
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
}
